import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';
import { getPrimaryProductImage } from '../utils/productImages';

function WishlistPage() {
  const { wishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();

  return (
    <div className="wishlist-page">
      <Helmet>
        <title>My Wishlist – Hercles Global</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header backTo="/" backLabel="← Continue Shopping" />
      <div className="wishlist-page-inner">
        <h1 className="wishlist-page-title">My Wishlist</h1>
        {wishlist.length === 0 ? (
          <div className="wishlist-empty">
            <p>Your wishlist is empty.</p>
            <Link to="/" className="order-btn" style={{ textDecoration: 'none', display: 'inline-block', marginTop: 16 }}>
              Browse Products
            </Link>
          </div>
        ) : (
          <div className="hp-product-grid">
            {wishlist.map(item => {
              const img = getPrimaryProductImage(item);
              return (
                <div key={item.id} className="wishlist-card">
                  <Link to={`/product/${item.slug || item.id}`} style={{ textDecoration: 'none', display: 'block' }}>
                    <div className="hp-card-img-wrap">
                      {img
                        ? <img src={img} alt={item.name} className="hp-card-img visible" loading="lazy" />
                        : <div className="hp-card-no-img">No Image</div>}
                    </div>
                    <div className="hp-card-info">
                      <p className="hp-card-name">{item.name}</p>
                      <p className="hp-card-price">KES {parseFloat(item.price).toLocaleString('en-KE', {minimumFractionDigits:2, maximumFractionDigits:2})}</p>
                    </div>
                  </Link>
                  <div className="wishlist-card-actions">
                    <button className="cart-btn" style={{ flex: 1 }} onClick={() => addToCart(item, 1)}>
                      Add to Cart
                    </button>
                    <button className="cart-page-remove" onClick={() => removeFromWishlist(item.id)} aria-label="Remove">✕</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default WishlistPage;
